export enum CaseFundStatus {
  SINGLE_CASE = "SINGLE_CASE",
  SUBSCRIPTION = "SUBSCRIPTION",
}
